/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Determine if the current screen is within an organization.
 * @export
 * @returns {boolean} True if the organization webpath is found.
 */
export const isOrganisation = (): boolean => {
  return location.pathname.indexOf(`/organization/`) === 0;
};
